import React from 'react';

const SummaryCard = ({ title, data, color }) => {
    const total = data.reduce((sum, item) => sum + parseInt(item.count), 0);
    
    return (
        <div style={{
            background: 'white',
            borderRadius: '10px',
            padding: '20px',
            boxShadow: '0 2px 4px rgba(0,0,0,0.1)',
            margin: '10px',
            flex: 1
        }}>
            <h3 style={{ marginBottom: '15px', color: '#333', borderBottom: `3px solid ${color}`, paddingBottom: '10px' }}>
                {title}
            </h3>
            {data.slice(0, 5).map((item, idx) => (
                <div key={idx} style={{ marginBottom: '12px' }}>
                    <div style={{ display: 'flex', justifyContent: 'space-between', marginBottom: '5px' }}>
                        <span>{item.name || item.age || item.gender || item.electricity || Object.values(item)[0]}</span>
                        <span style={{ fontWeight: 'bold', color: color }}>{item.count}</span>
                    </div>
                    <div style={{
                        background: '#f0f2f5',
                        borderRadius: '10px',
                        height: '8px',
                        overflow: 'hidden'
                    }}>
                        <div style={{
                            width: `${(item.count / total) * 100}%`,
                            background: color,
                            height: '100%',
                            borderRadius: '10px'
                        }} />
                    </div>
                </div>
            ))}
        </div>
    );
};

export default SummaryCard;